import React from 'react'
import { Col, Container, Row} from 'react-bootstrap'
import {
  ROOT_URL,
} from '../../constants/urls'
import { 
  QUOTE_ICON
} from '../../constants/svgs'
import {useNavigate} from 'react-router'
import {localise} from '../../services/LocalizationServices'
import { CardTestimonial } from '../../components/cards/CardTestimonial'
import {Helmet} from 'react-helmet'

const Testimonials = () => {
  const history = useNavigate()

  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' name='description' content={localise('SEO.testimonials.description')}/>
        <meta charSet='utf-8' name='keywords' content={localise('SEO.testimonials.keywords')}/>
        <title>{localise('SEO.testimonials.title')}</title>
      </Helmet>
      <Container className='padding-under-nav'>
        <div>
          <div className='header-section mb-3'>
            {localise('testimonials.title')}
          </div>
          <div className='d-flex justify-content-center'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href={ROOT_URL}>{localise('nav.home')}</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {localise('nav.testimonials')}
                </li>
              </ol>
            </nav>
          </div>
          <div className='homepage-about-title text-center mt-5'>
            {localise('testimonials.tagline')}
          </div>
          <div>
          <div className='about-Subheader text-center mt-4'>
            {localise('testimonials.introTitle')}
          </div>
          <div className='w-100 my-4'>
            </div>
          </div>
        </div>
        <div>
          <div className='my-4'>
            <div className="full-width-cards">
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.anxietyTitle')} 
                description={localise('testimonials.anxiety')}
                name={localise('testimonials.anxietyName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.confidenceTitle')} 
                description={localise('testimonials.confidence')}
                name={localise('testimonials.confidenceName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.fearsTitle')} 
                description={localise('testimonials.fears')}
                name={localise('testimonials.fearsName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.abuseTitle')} 
                description={localise('testimonials.abuse')}
                name={localise('testimonials.abuseName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.weightTitle')} 
                description={localise('testimonials.weightLoss')}
                name={localise('testimonials.weightLossName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.weightTitle')} 
                description={localise('testimonials.weightLoss2')}
                name={localise('testimonials.weightLoss2Name')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.smokingTitle')} 
                description={localise('testimonials.smoking')}
                name={localise('testimonials.smokingName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.childbirthTitle')} 
                description={localise('testimonials.childbirth')}
                name={localise('testimonials.childbirthName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.ibsTitle')} 
                description={localise('testimonials.ibs')}
                name={localise('testimonials.ibsName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.ibsTitle')} 
                description={localise('testimonials.ibsMam')}
                name={localise('testimonials.ibsMamName')}
              />
              <CardTestimonial 
                image={QUOTE_ICON} 
                title={localise('services.nervesTitle')} 
                description={localise('testimonials.nerves')}
                name={localise('testimonials.nervesName')}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Testimonials